export const Publications = Object.freeze({
  listOrgs: 'listOrgs',
  listMyOrgs: 'listMyOrgs',
  listUsers: 'listUsers',
  listAccounts: 'listAccounts',
  listAccountUsers: 'listAccountUsers',
  tailLogs: 'tailLogs',
  listSupportTicketMessages: 'listSupportTicketMessages',
  conversationMessages: 'conversationMessages',
  conversations: 'conversations',
  unreadMessageReceipts: 'unreadMessageReceipts',
  conversationReadReceipts: 'conversationReadReceipts',
  notifications: 'notifications',
  notificationsCount: 'notificationsCount',
  getProject: 'getProject',
  realtimeUpdate: 'realtimeUpdate',
  projectManagementProjectDetail: 'projectManagementProjectDetail',
  projectManagementPipelineProjects: 'projectManagementPipelineProjects',
  projectManagementPipelineDetails: 'projectManagementPipelineDetails',
  projectManagementInvoices: 'projectManagementInvoices',
  resigenProjects: 'resigenProjects',
});